import { combineReducers } from 'redux';
import * as types from '../constants';
import barberFilter from '../../../common/reducers/barberFilter';

export default combineReducers({
  barberFilter: barberFilter({
    add: types.ADD_BARBER_FILTER_REPORT,
    remove: types.REMOVE_BARBER_FILTER_REPORT,
    show: types.SHOW_ALL_BARBER_FILTERS_REPORT,
    hide: types.HIDE_ALL_BARBER_FILTERS_REPORT,
    set: types.SET_BARBER_FILTER,
    includeUnassigned: true,
  }),
});

